import React, { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { authClient } from '../lib/authClient';
import PasswordInput from '../components/PasswordInput';
import { styles } from './SignIn';

// The emailed link goes through Better Auth, which redirects here with ?token=… when the token
// is valid and ?error=INVALID_TOKEN when it has expired or been used.
export default function ResetPassword() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const token = params.get('token');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm]   = useState('');
  const [error, setError]       = useState('');
  const [expired, setExpired]   = useState(!token || params.get('error') === 'INVALID_TOKEN');
  const [loading, setLoading]   = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (password !== confirm) {
      setError("The two passwords don't match.");
      return;
    }
    setLoading(true);
    try {
      const { error: authError } = await authClient.resetPassword({ newPassword: password, token });
      if (!authError) {
        navigate('/sign-in', { replace: true, state: { notice: 'Password changed: sign in with your new password.' } });
      } else if (authError.code === 'INVALID_TOKEN') {
        setExpired(true);
      } else if (authError.status === 429) {
        setError('Too many attempts, try again in a few minutes.');
      } else {
        setError(authError.message || 'Something went wrong. Please try again.');
      }
    } catch {
      setError('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <h1 style={styles.title}>Set a new password</h1>
        {expired ? (
          <>
            <p style={styles.text}>This reset link has expired or already been used.</p>
            <Link to="/forgot-password" style={{ ...styles.button, display: 'block', textAlign: 'center', textDecoration: 'none' }}>
              Send a new link
            </Link>
          </>
        ) : (
          <form onSubmit={handleSubmit} style={styles.form}>
            <PasswordInput
              autoComplete="new-password"
              placeholder="New password (at least 8 characters)"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
              minLength={8}
              style={styles.input}
            />
            <PasswordInput
              autoComplete="new-password"
              placeholder="Confirm new password"
              value={confirm}
              onChange={e => setConfirm(e.target.value)}
              required
              minLength={8}
              style={styles.input}
            />
            {error && <p style={styles.error}>{error}</p>}
            <button type="submit" disabled={loading} style={styles.button}>
              {loading ? 'Saving…' : 'Change password'}
            </button>
          </form>
        )}
        <p style={styles.footer}>
          <Link to="/sign-in" style={styles.link}>Back to sign in</Link>
        </p>
      </div>
    </div>
  );
}
